<nz-modal [nzVisible]="isVisible" [nzFooter]="null" [nzClosable]="false" [nzWidth]="560"
  nzClassName="command-palette-modal" (nzOnCancel)="close()" (nzAfterOpen)="focusSearch()">
  <ng-container *nzModalContent>
    <div class="palette" dir="rtl" (keydown)="onKeydown($event)">
      <div class="palette-input">
        <span nz-icon nzType="search" nzTheme="outline"></span>
        <input #search type="text" autocomplete="off" placeholder="ابحث عن صفحة…" [(ngModel)]="query"
          (ngModelChange)="onQueryChange()" />
        <kbd>Esc</kbd>
      </div>

      <div class="palette-results">
        <ng-container *ngFor="let section of sections">
          <div class="palette-section">{{ section.title }}</div>

          <button *ngFor="let row of section.rows" type="button" class="palette-item"
            [id]="'palette-item-' + row.index" [class.is-active]="row.index === activeIndex"
            (mouseenter)="activeIndex = row.index" (click)="go(row.match)">
            <span class="palette-icon" nz-icon *ngIf="row.match.leaf.icon" [nzType]="row.match.leaf.icon"
              nzTheme="outline"></span>
            <span class="palette-label">{{ row.match.leaf.label }}</span>
            <span class="palette-trail" *ngIf="trail(row.match) as path">{{ path }}</span>
            <span class="palette-star" [class.is-pinned]="isFavorite(row.match)"
              [attr.aria-label]="isFavorite(row.match) ? 'إزالة من المفضلة' : 'إضافة إلى المفضلة'"
              (click)="toggleFavorite(row.match, $event)" nz-icon nzType="star"
              [nzTheme]="isFavorite(row.match) ? 'fill' : 'outline'"></span>
          </button>
        </ng-container>

        <nz-empty *ngIf="!flatResults.length" nzNotFoundContent="لا توجد نتائج"></nz-empty>
      </div>
    </div>
  </ng-container>
</nz-modal>
